<template>
  <Row>
    <Col span="18">
      <Input v-model="grade" placeholder="grade" class="public-inp" />
      <Input v-model="gradeCode" placeholder="gradeCode" class="public-inp" />
      <Select v-model="gradeGroup" placeholder="Grade Group" class="public-inp">
        <Option
          v-for="(item, i) in gradeGroupList"
          :key="i"
          :value="item.gradeGroup"
          >{{ item.gradeGroup }}</Option
        >
      </Select>
      <Select v-model="status" placeholder="请选择状态" class="public-inp">
        <Option value="">全部</Option>
        <Option value="0">启用</Option>
        <Option value="1">禁用</Option>
      </Select>
      <Button
        type="primary"
        icon="md-search"
        @click="getList()"
        v-access="'groupInfo.query'"
        >搜索</Button
      >
      <Button @click="resetList()" v-access="'groupInfo.reset'">重置</Button>
    </Col>
    <Col span="6">
      <Button
        type="primary"
        icon="md-add"
        class="public-fr"
        v-access="'groupInfo.add'"
        @click="openFn()"
        >添加等级</Button
      >
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <span v-show="false">{{ row.code }}</span>
          {{ (page - 1) * pageSize + index + 1 }}
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            v-access="'groupInfo.status'"
            :value="row.status == 0"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row }" slot="avatar">
          <Avatar :src="row.d" />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            @click="openFn(row, index)"
            v-access="'groupInfo.edit'"
            >编辑</a
          >
          <a
            href="javascript:;"
            @click="removeFn(index, row)"
            v-access="'groupInfo.delete'"
            >删除</a
          >
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="pageSize"
        :current="page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        show-elevator
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
    <!-- 分级 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增分级' : '编辑分级'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="100"
      >
        <FormItem label="grade" prop="grade">
          <Input v-model="formItem.grade" placeholder="grade" />
        </FormItem>
        <FormItem label="gradeCode" prop="gradeCode">
          <Input v-model="formItem.gradeCode" placeholder="gradeCode" />
        </FormItem>
        <FormItem label="gradeGroup" prop="gradeGroup">
          <Select v-model="formItem.gradeGroup" placeholder="Grade Group">
            <Option
              v-for="(item, i) in gradeGroupList"
              :key="i"
              :value="item.gradeGroup"
              >{{ item.gradeGroup }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="状态">
          <i-switch
            v-model="formItem.status"
            true-value="0"
            false-value="1"
          ></i-switch>
        </FormItem>
      </Form>
    </Modal>
  </Row>
</template>
<script>
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "grade",
    key: "grade",
  },
  {
    title: "gradeCode",
    key: "gradeCode",
  },
  {
    title: "gradeGroup",
    key: "gradeGroup",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  data() {
    return {
      loading: false,
      grade: "",
      gradeCode: "",
      status: "",
      gradeGroup: "",
      gradeGroupList: [],
      columns,
      tbList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      formModel: false,
      formTitle: 0,
      formModalLoading: true,
      formItem: {
        grade: "",
        gradeCode: "",
        gradeGroup: "",
        status: "0",
      },
      updateId: "",
      ruleValidate: {
        grade: [{ required: true, message: "请输入grade", trigger: "blur" }],
        gradeCode: [
          { required: true, message: "请输入gradeCode", trigger: "blur" },
        ],
        gradeGroup: [
          { required: true, message: "请选择gradeGroup", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getGradeGroup();
    this.getList();
  },
  methods: {
    getGradeGroup() {
      this.$api.gradeGroupSearchAll({}).then((res) => {
        if (res.code == "200") {
          this.gradeGroupList = res.data;
        }
      });
    },
    // 列表
    getList() {
      let data = {
        grade: this.grade,
        gradeCode: this.gradeCode,
        status: this.status,
        gradeGroup: this.gradeGroup,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.gradeSearch(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.grade = "";
      this.gradeCode = "";
      this.status = "";
      this.gradeGroup = "";
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 打开新增编辑
    openFn(d, i) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      if (d) {
        this.updateId = d.id;
        this.formItem = {
          grade: d.grade,
          gradeCode: d.gradeCode,
          status: d.status,
          gradeGroup: d.gradeGroup,
        };
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 删除
    removeFn(i, d) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.grade}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api.gradeDelete({ id: d.id }).then((res) => {
            if (res.code == "200") {
              this.$Message.success("删除成功");
              this.getList();
            }
          });
        },
      });
    },
    // 状态
    stateChange(v, d, i) {
      let http = d.status == 0 ? "gradeDisable" : "gradeEnable";
      this.$api[http]({ id: d.id }).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
    // 确定
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      let data = this.formItem;
      let http = "gradeAdd";
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          if (this.formTitle == 1) {
            data.id = this.updateId;
            http = "gradeUpdate";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.getList();
            }
          });
        }
      });
    },
    cancelAction() {
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/other/groupInfo.vue